<!--
File: catalog-home.component.html
Project: catalog-cloud
File Created: Wednesday, 22nd December 2021 12:48:17
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Friday, 13th December 2024 10:13:32 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<!-- <mat-sidenav-container
fullscreen
fixedInViewport="true"
autosize="true"
class="main-sidenav"
>

<mat-sidenav #sidenav mode="side" opened  class="left-side-menu">
  <app-side-menu context="catalog"> </app-side-menu>
</mat-sidenav>

<div class="content-sidenav">
  <cc-top-menu></cc-top-menu>
  <app-catalog-list></app-catalog-list>
</div>

</mat-sidenav-container> -->

<!-- <cc-top-menu context="catalog"></cc-top-menu> -->
  <app-catalog-list></app-catalog-list>

